import React from 'react'

import { FormattedMessage } from 'react-intl'
import Link from 'next/link'
import Paper from '@mui/material/Paper'
import { BiMenu } from 'react-icons/bi'

import { Provider as MenuProvider } from 'contexts/menu'
import { ArchiveDatePicker } from './ArchiveDatePicker'
import { Geocoder } from './Geocoder'
import { useMenu } from 'contexts/menu'
import css from './ArchiveWidget.module.css'

export const ArchiveWidget = () => {
    const { toggle } = useMenu()

    return (
        <MenuProvider>
            <Paper className={css.Paper} elevation={3}>
                <BiMenu size="22px" className={css.Menu} onClick={toggle} />
                <h1 className={css.Title}>
                    <FormattedMessage
                        defaultMessage="Forecast Archive"
                        description="Heading for the forecast archive widget"
                    />
                </h1>
                <p className={css.Sub}>
                    <FormattedMessage
                        defaultMessage="This is historical data for the point selected on the map. <b>Note</b>: To see archived forecasts from before April 2022, please see <a>this page</a>."
                        description="Subheading for the forecast archive widget"
                        values={{
                            a: (...chunks) => (
                                <Link href="/forecasts/archive/pre-flexible-regions">
                                    <a>{chunks}</a>
                                </Link>
                            ),
                            b: (...chunks) => <strong>{chunks}</strong>,
                        }}
                    />
                </p>
                <div className={css.Inputs}>
                    <Geocoder />
                    <ArchiveDatePicker />
                </div>
            </Paper>
        </MenuProvider>
    )
}
